// extracted by mini-css-extract-plugin
export default {"container":"GamesView_container__EqaXv","btn":"GamesView_btn__0-yIj"};